/**
 * @module
 * @description Some event functions for use in other modules
 */

export function ready(fn) {
	if (document.readyState !== 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

export function trigger(opts) {
	const options = {
		data: {},
		el: document,
		event: '',
		native: true,
		...opts,
	};

	let event;
	if (options.native) {
		event = document.createEvent('HTMLEvents');
		event.initEvent(options.event, true, false);
	} else {
		try {
			event = new CustomEvent(options.event, { detail: options.data });
		} catch (e) {
			event = document.createEvent('CustomEvent');
			event.initCustomEvent(options.event, true, true, options.data);
		}
	}

	options.el.dispatchEvent(event);
}
